<template>
    <header class="d-flex justify-content-between">
        <div class="header-menu--mobile">
            <div class="header-menu--mobile-container">
                <div>
                    <a href="https://stronghold.thetanuts.finance/">
                        <!-- <img
                            src="/images/landing-page/logo-mobile.svg"
                            alt="logo mobile"
                        /> -->
                        <img
                            class="logo logo-mobile"
                            src="/images/landing-page/logo-thetanuts-2.svg"
                            alt="logo mobile"
                        />
                    </a>
                </div>
                <div @click="toggleMenu()" class="header-menu__btn">
                    <img :src="iconMenu" alt="burger menu" />
                </div>
            </div>
            <div class="header-menu--mobile-content" v-if="isMenuOpen">
                <div
                    class="d-flex flex-column header-menu--mobile-content__container"
                >
                    <div class="mobileNav__harvest d-none">
                        <a
                            href="https://stronghold.thetanuts.finance/"
                            @click.native="scrollableBody()"
                        >
                            <span class="animated"
                                >Swap Now

                                <div class="d-inline-block">
                                    <svg
                                        width="23"
                                        height="23"
                                        viewBox="0 0 23 23"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <defs>
                                            <linearGradient
                                                id="logo-gradient"
                                                x1="50%"
                                                y1="0%"
                                                x2="50%"
                                                y2="100%"
                                            >
                                                <stop
                                                    offset="0%"
                                                    stop-color="#1cc8c1"
                                                >
                                                    <animate
                                                        attributeName="stop-color"
                                                        values="#1cc8c1; #05feb1; #d9ef46; #ff843f; #a2f9e4; #05feb1"
                                                        dur="4s"
                                                        repeatCount="indefinite"
                                                    ></animate>
                                                </stop>

                                                <stop
                                                    offset="100%"
                                                    stop-color="#05feb1"
                                                >
                                                    <animate
                                                        attributeName="stop-color"
                                                        values="#05feb1; #a2f9e4; #ff843f; #d9ef46; #05feb1; #1cc8c1"
                                                        dur="4s"
                                                        repeatCount="indefinite"
                                                    ></animate>
                                                </stop>
                                            </linearGradient>
                                        </defs>
                                        <path
                                            d="M22.0607 12.7364C22.6464 12.1507 22.6464 11.2009 22.0607 10.6151L12.5147 1.06918C11.9289 0.483393 10.9792 0.483393 10.3934 1.06918C9.80761 1.65497 9.80761 2.60471 10.3934 3.1905L18.8787 11.6758L10.3934 20.1611C9.80761 20.7468 9.80761 21.6966 10.3934 22.2824C10.9792 22.8682 11.9289 22.8682 12.5147 22.2824L22.0607 12.7364ZM0 13.1758H21V10.1758H0V13.1758Z"
                                            fill="url('#logo-gradient')"
                                            style=""
                                        ></path>
                                    </svg>
                                </div>
                            </span>
                        </a>
                    </div>
                    <div class="mobileNav__thetanuts--v1">
                        <a
                            href="https://stronghold.thetanuts.finance/"
                            @click.native="scrollableBody()"
                        >
                            <span class="animated thetanuts--v1">
                                Thetanuts Stronghold
                            </span>
                        </a>
                        <a class="mobileNav__sublink d-none" href="#!">
                            Theta-Index
                        </a>
                        <a class="mobileNav__sublink d-none" href="#!">
                            Portfolio
                        </a>
                    </div>
                    <div class="mobileNav__thetanuts--v0">
                        <router-link
                            :to="{ name: 'vault' }"
                            @click.native="scrollableBody()"
                        >
                            <span class="animated thetanuts--v1">
                                Thetanuts Basic
                            </span>
                        </router-link>
                    </div>
                    <div class="mobileNav__docs">
                        <span class="uppercase title-link">
                            <a
                                target="blank"
                                href="https://docs.thetanuts.finance/"
                                >Docs</a
                            >
                        </span>
                    </div>
                    <div class="mobileNav__community-2">
                        <div>
                            <a
                                href="https://twitter.com/ThetanutsFi"
                                target="_blank"
                            >
                                <img
                                    src="/images/icon-twitter-white.svg"
                                    alt="twitter"
                                />
                            </a>
                        </div>
                        <div>
                            <a
                                href="https://thetanutsfinance.medium.com/"
                                target="_blank"
                            >
                                <img
                                    src="/images/icon-medium-white.svg"
                                    alt="medium"
                                />
                            </a>
                        </div>
                        <div>
                            <a href="https://dsc.gg/thetanuts" target="_blank">
                                <img
                                    src="/images/icon-discord-white.svg"
                                    alt="discord"
                                />
                            </a>
                        </div>
                        <div>
                            <a
                                href="https://thetanuts.substack.com"
                                target="_blank"
                            >
                                <img
                                    src="/images/icon-substack-white.svg"
                                    alt="substack"
                                />
                            </a>
                        </div>
                    </div>
                    <div class="mobileNav__community d-none">
                        <span class="uppercase">Community</span>
                        <div>
                            <a
                                target="blank"
                                href="https://twitter.com/ThetanutsFi"
                                >Twitter</a
                            >
                        </div>
                        <div>
                            <a
                                target="blank"
                                href="https://thetanutsfinance.medium.com/"
                                >Medium</a
                            >
                        </div>
                        <div>
                            <a target="blank" href="https://dsc.gg/thetanuts"
                                >Discord</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="header-menu--tablet">
            <div class="d-flex align-items-center">
                <a href="https://stronghold.thetanuts.finance/">
                    <img
                        class="logo"
                        src="/images/landing-page/logo-thetanuts-2.svg"
                        alt="logo theta nuts"
                    />
                </a>
            </div>
            <div>
                <ul class="d-flex p-0 list-unstyled align-items-center">
                    <li class="position-relative header-menu__has-dropdown">
                        <span class="d-flex" style="gap: 8px;"
                            >Community
                            <img
                                class="ms-1"
                                src="/images/landing-page/icon-caret-down-white.svg"
                                alt="icon dropdown"
                        /></span>
                        <div class="header-menu__dropdown">
                            <ul>
                                <li>
                                    <a
                                        target="blank"
                                        href="https://twitter.com/ThetanutsFi"
                                        >Twitter</a
                                    >
                                </li>
                                <li>
                                    <a
                                        target="blank"
                                        href="https://thetanutsfinance.medium.com/"
                                        >Medium</a
                                    >
                                </li>
                                <li>
                                    <a
                                        target="blank"
                                        href="https://dsc.gg/thetanuts"
                                        >Discord</a
                                    >
                                </li>
                                <li>
                                    <a
                                        target="blank"
                                        href="https://thetanuts.substack.com"
                                        >Substack</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="position-relative">
                        <a
                            target="blank"
                            href="https://docs.thetanuts.finance/"
                        >
                            <span>Docs</span>
                        </a>
                    </li>
                    <li v-show="!hideSwapNowButton">
                        <a href="https://stronghold.thetanuts.finance/">
                            <AppButton>
                                Swap Now
                            </AppButton>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script>
import AppButton from "./AppButton.vue";

export default {
    components: {
        AppButton
    },
    props: {
        hideSwapNowButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isMenuOpen: false
        };
    },
    computed: {
        iconMenu() {
            return this.isMenuOpen
                ? "/images/header/icon-close.svg"
                : "/images/header/icon-menu.svg";
        }
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;

            if (this.isMenuOpen) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
        },
        scrollableBody() {
            document.body.style.overflow = "auto";
        }
    }
};
</script>

<style lang="scss" scoped>
header {
    .logo {
        transition: all ease 0.3s;

        &:hover {
            filter: drop-shadow(0px 0px 15px #1ae899);
        }
    }

    .header-menu--mobile {
        display: flex;
        width: 100%;
        flex-direction: column;
        position: absolute;
        z-index: 10;

        .logo-mobile {
            width: 180px;

            @media only screen and (min-width: 768px) {
                width: 263px;
            }
        }

        .header-menu--mobile-container {
            display: flex;
            width: 100%;
            padding: 13px 16px;
            background: rgba(0, 0, 0, 0.9);
            justify-content: space-between;
            align-items: center;

            @media only screen and (min-width: 768px) {
                display: none;
            }

            .header-menu__btn {
                cursor: pointer;
            }
        }

        .header-menu--mobile-content {
            display: flex;
            flex-direction: column;
            background: rgba(0, 0, 0, 0.9);
            height: 100vh;

            ul {
                flex-direction: column;
                margin: 20px 0;

                @media only screen and (min-width: 768px) {
                    margin: 25px 0;
                }

                li {
                    padding: 15px;
                }
            }

            .header-menu--mobile-content__container {
                // width: 90%;
                width: 100%;
                padding: 35px 40px;

                > div {
                    &.mobileNav__thetanuts--v1 {
                        margin-bottom: 84px;
                        display: flex;
                        flex-direction: column;
                        gap: 16px;

                        a {
                            color: #ffffff;
                        }
                    }
                    &.mobileNav__thetanuts--v0 {
                        margin-bottom: 95px;
                    }

                    .mobileNav__sublink {
                        font-family: Sofia Sans;
                        font-size: 22px;
                        font-weight: 500;
                        line-height: 35px;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: uppercase;
                    }

                    &.mobileNav__harvest {
                        margin-bottom: 100px;

                        span {
                            font-family: Sofia Sans;
                            font-size: 55px;
                            font-style: normal;
                            font-weight: 900;
                            line-height: 55px;
                            letter-spacing: 0em;

                            display: inline-block;
                            transition: all ease 0.3s;

                            &:hover {
                                transform: scale(1.1);
                            }
                        }

                        div {
                            padding: 10px;
                            box-sizing: content-box;
                            border-radius: 50%;
                            background: linear-gradient(
                                95.12deg,
                                #1cc8c1 0%,
                                #05feb1 0.01%,
                                #d9ef46 28.64%,
                                #ff843f 49.48%,
                                #a2f9e4 73.96%,
                                #05feb1 100%
                            );
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                            cursor: pointer;
                            z-index: 1;
                            background-size: 300%;
                            background-position: -100%;
                            animation: animatedText 5s infinite
                                alternate-reverse;
                            transition: all ease 0.3s;

                            position: relative;
                            width: 20px;
                            height: 20px;
                            transform: translateY(50%);

                            &:before {
                                content: "";
                                background: #172120;
                                position: absolute;
                                top: 2px;
                                left: 2px;
                                bottom: 2px;
                                right: 2px;
                                z-index: -1;
                                border-radius: 50%;
                            }

                            svg {
                                // border: 3px solid white;
                                // padding: 10px;
                                // box-sizing: content-box;
                                // border-radius: 50%;

                                top: -20px;
                                left: -1px;
                                position: relative;
                            }
                        }
                    }
                    &.mobileNav__docs {
                        // margin-bottom: 60px;

                        span {
                            // font-family: Inter;
                            // font-size: 24px;
                            // font-style: normal;
                            // font-weight: 700;
                            // line-height: 38px;
                            // letter-spacing: 0px;
                            font-family: Sofia Sans;
                            font-size: 26px;
                            font-weight: 400;
                            line-height: 42px;
                            letter-spacing: 0px;
                            text-align: left;
                            text-transform: uppercase;

                            &.title-link {
                                a {
                                    color: #fff;

                                    &:hover {
                                        color: #4ec575;
                                    }
                                }
                            }
                        }
                    }
                    &.mobileNav__community {
                        span {
                            font-family: Inter;
                            font-size: 24px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 38px;
                            letter-spacing: 0px;

                            display: inline-block;
                            margin-bottom: 10px;

                            & ~ div {
                                a {
                                    font-family: Inter;
                                    font-size: 18px;
                                    font-style: normal;
                                    font-weight: 500;
                                    line-height: 40px;
                                    letter-spacing: 0px;

                                    color: #fff;
                                    text-decoration: none;

                                    &:hover {
                                        // opacity: 0.8;
                                        color: #4ec575;
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }
                    &.mobileNav__community-2 {
                        display: flex;
                        align-items: center;
                        gap: 40px;
                        margin-top: 30px;
                    }
                }
            }
        }
    }

    .header-menu--tablet {
        display: none;
        padding: 0 50px;

        @media only screen and (min-width: 768px) {
            display: flex;
            width: 100%;
            justify-content: space-between;
        }
        @media only screen and (min-width: 1440px) {
            padding: 0 150px;
            padding-left: 10vw;
            // padding-right: 8.89vw;
        }
    }

    .header-menu__has-dropdown {
        z-index: 10;

        span {
            cursor: pointer;
        }

        &:hover {
            opacity: 0.8;

            .header-menu__dropdown {
                display: block;
            }
        }
    }

    .header-menu__dropdown {
        display: none;
        margin: 0;
        position: relative;
        z-index: 10;
        padding: 15px 0;
        width: auto;

        @media only screen and (min-width: 768px) {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }

        ul {
            z-index: 10;
            list-style: none;
            padding-left: 0;
            margin: 0;
            border-radius: 5px;
            background: rgb(0 0 0 / 16%);

            li {
                text-align: left;
                padding: 15px;

                a {
                    cursor: pointer;
                    color: white;

                    &:hover {
                        // opacity: 0.8;
                        color: #4ec575;
                    }
                }
            }
        }
    }

    ul {
        margin: 10px 0;

        li {
            font-family: Inter;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: 21px;
            letter-spacing: 0px;
            text-align: center;
            text-transform: uppercase;

            @media only screen and (min-width: 1440px) {
                font-size: 17px;
                line-height: 27px;
            }

            margin: 0 10px;
            padding: 10px;

            a {
                color: inherit;

                &:hover {
                    // opacity: 0.8;
                    color: #4ec575;
                }
            }
        }
    }

    .thetanuts--v1 {
        font-family: Sofia Sans;
        font-size: 30px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0em;
        text-align: left;
    }

    .animated {
        background-image: linear-gradient(
            95.12deg,
            #1cc8c1 0%,
            #05feb1 0.01%,
            #d9ef46 28.64%,
            #ff843f 49.48%,
            #a2f9e4 73.96%,
            #05feb1 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;

        background-size: 300%;
        background-position: -100%;

        animation: animatedText 5s infinite alternate-reverse;
    }
}

@keyframes animatedText {
    to {
        background-position: 100%;
    }
}
</style>
